// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selected {\n  background-color: pink;\n}\n\n.highSuccessRate {\n  color: red;\n}\n\n.rowContainer {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n\n.rowContainer1 {\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n}\n\n.warningInfo {\n  padding-left: 32px;\n  font-size: 14px;\n  color: red;\n}\n\n\n\n.interviewInformation .table td,\n.interviewInformation .table th {\n  padding: 0.4rem;\n}", ""]);
// Exports
module.exports = exports;
